import { Icon } from "icons";
import { useTranslation } from "react-i18next";
import { cn } from "ui";

interface SaveIndicatorProps {
  status: "hidden" | "loading" | "success" | "error";
  className?: string;
}

export function SaveIndicator(props: SaveIndicatorProps) {
  const { status, className = "" } = props;
  const { t } = useTranslation();

  if (status === "hidden") {
    return null;
  }

  return (
    <div
      className={cn(
        "flex items-center gap-2 text-sm text-muted-foreground whitespace-nowrap",
        className,
      )}
    >
      {status === "loading" && (
        <>
          <Icon name="tabler-loader-2" className="h-4 w-4 animate-spin" />
          <span>{t("saveIndicator.saving")}</span>
        </>
      )}
      {status === "success" && (
        <>
          <Icon name="tabler-check" className="h-4 w-4 text-green-600" />
          <span className="text-green-600">{t("saveIndicator.saved")}</span>
        </>
      )}
      {status === "error" && (
        <>
          <Icon name="tabler-check" className="h-4 w-4 text-red-600" />
          <span className="text-red-600">{t("saveIndicator.error")}</span>
        </>
      )}
    </div>
  );
}
